import React from 'react';
import DatePickerComponent from '../common/DatePickerComponent';
import Table from "react-bootstrap/Table";
import { RateCardTableColumns } from '../../constant';
import { Tooltip as WmsTooltip } from "react-tooltip";
import RateCardHistoryDialog from './History';
import PropTypes from 'prop-types';

const ServiceRateCardComponent = (props) => {
    const { handleServiceDetails, handleInputBlur, isEditable, handleDateChange, formData, handleSaveService, rateCardDetails } = props;
    const [historyModalShow, setHistoryModalShow] = React.useState({ show: false, item: {} });

    return (
        <div className="col-lg-12">
            <div className="main_content_table_history">
                <Table
                    className={`table-height cus-left-right-col-layout`}
                >
                    <thead className="tbl-btch">
                        <tr className="table-rw-batch">
                            {RateCardTableColumns.map((item, index) => (
                                <th key={item.companyName}>{item.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {formData.serviceDetails?.map((seller, index) => (
                            <tr className="table-rw-batch" key={seller.AccountingServiceMaster_Id}>
                                <td width={'10%'}>{seller.ServiceType}</td>
                                <td>{seller.TransactionType}</td>
                                <td>{seller.ChargeType}</td>
                                <td>{seller.SizeType}</td>
                                <td>{seller.UnitType}</td>
                                <td width={'18%'}>
                                    <DatePickerComponent
                                        dateField={seller.ValidFrom}
                                        handleDateChange={(date) => handleDateChange(date, 'ValidFrom', index)}
                                        fieldName="ValidFrom"
                                        dateFormat="MM-dd-yyyy, h:mm aa"
                                        timeSelect={true}
                                    />
                                </td>
                                <td width={'18%'}>
                                    <DatePickerComponent
                                        dateField={seller.ValidTo}
                                        handleDateChange={(date) => handleDateChange(date, 'ValidTo', index)}
                                        fieldName="ValidTo"
                                        dateFormat="MM-dd-yyyy, h:mm aa"
                                        timeSelect={true}
                                    />
                                </td>
                                <td width={'10%'}>
                                    <div className='dollarPrefix'>
                                        <input
                                            className={`form-control amount`}
                                            type={"number"}
                                            name="amount"
                                            value={seller.Amount}
                                            onChange={(e) => handleServiceDetails(e.target.value, 'Amount', index)}
                                            onBlur={handleInputBlur}
                                            min={0}
                                            disabled={isEditable}
                                            onKeyDown={(evt) =>
                                                ["e", "E", "+", "-"].includes(evt.key) &&
                                                evt.preventDefault()
                                            }
                                            onWheel={(e) => e.target.blur()}
                                        />
                                    </div>
                                </td>
                                <td width={'10%'}>
                                    <div className='dollarPrefix'>
                                        <input
                                            className={`form-control additionalCharge`}
                                            type={"number"}
                                            name="AdditionalCharge"
                                            value={seller.AdditionalCharge}
                                            onChange={(e) => handleServiceDetails(e.target.value, 'AdditionalCharge', index)}
                                            onBlur={handleInputBlur}
                                            min={0}
                                            disabled={isEditable}
                                            onKeyDown={(evt) =>
                                                ["e", "E", "+", "-"].includes(evt.key) &&
                                                evt.preventDefault()
                                            }
                                            onWheel={(e) => e.target.blur()}
                                        />
                                    </div>
                                </td>
                                <td className='p-0' width={'10%'}>
                                    <div className='action-icons'>
                                        <button type='button' className='btn iconBtns small' title='Save' id={`${seller.AccountingServiceMaster_Id}+${'save'}`} onClick={() => handleSaveService(seller, 'save')}>
                                            <i className="fa fa-check successBtn" aria-hidden="true"></i>
                                        </button>
                                        <button disabled={!seller.IsHistory} type='button' className='btn iconBtns small' title='History' id={`${seller.AccountingServiceMaster_Id}+${'history'}`} onClick={() => setHistoryModalShow({ show: true, item: seller })}>
                                            <i className="fa fa-clock-o errorBtn" aria-hidden="true"></i>
                                        </button>

                                        <WmsTooltip
                                            anchorId={`${seller.AccountingServiceMaster_Id}+${'save'}`}
                                            content={'Save'}
                                            place="right"
                                            className="tooltipWidth"
                                        />
                                        <WmsTooltip
                                            anchorId={`${seller.AccountingServiceMaster_Id}+${'history'}`}
                                            content={'History'}
                                            place="right"
                                            className="tooltipWidth"
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
            {historyModalShow.show && (
                <RateCardHistoryDialog
                    modalShow={historyModalShow}
                    setModalShow={setHistoryModalShow}
                    rateCardDetails={rateCardDetails}
                />
            )}
        </div>
    );

}
ServiceRateCardComponent.propTypes = {
    handleServiceDetails: PropTypes.func,
    handleInputBlur: PropTypes.func,
    isEditable: PropTypes.bool,
    handleDateChange: PropTypes.func,
    formData: PropTypes.object,
    handleSaveService: PropTypes.func,
    rateCardDetails: PropTypes.array
};

export default ServiceRateCardComponent;